var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"height":"360px","width":"380px","src":_vm.adminLoginFrameUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }